import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { resources } from "@constants/hardcoded-strings";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { getPolicyTypeById } from "@utils/policies/policy-util";
import { PolicyTypes } from "@enums/policy-types";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { PolicyDecisionActionTypes } from "@iddataweb/idw-common-ui/enums";

export const getPolicyDetailErrors = (axnuiContent: AXNUIContent, rpServiceConfiguration: FormattedRpServiceConfiguration | Partial<FormattedRpServiceConfiguration>) => {
    let count = 0;
    let noStepUpApiKeyError = null;
    const { policyConfig, policies } = rpServiceConfiguration;
    const usePolicyManager = isStringTrue(rpServiceConfiguration.usePolicyManager);
    const policyType = getPolicyTypeById(usePolicyManager, policyConfig, policies);


    const policyConfigDecisionsRetryErrors: { [key: string]: React.ReactNode } = {};
    if (policies.length && policyType !== PolicyTypes.NONE) {
        if (policyConfig !== null) {
            policyConfig.decisions.forEach(decision => {
                if (decision.policyDecisionType === PolicyDecisionActionTypes.DENY) {
                    let key = decision.uuid;
                    let retryMessageId = axnuiContent.policyDecisionRetryMessage[decision.uuid]?.retryMessage;
                    if (decision.id !== null) {
                        retryMessageId = axnuiContent.policyDecisionRetryMessage[decision.id]?.retryMessage;
                        key = decision.id;
                    }
                    if (retryMessageId === '') {
                        policyConfigDecisionsRetryErrors[key] = (
                            <ErrorAlert key={key}>
                                <span>{resources.pages.verificationServiceDetails.tabs.policies.sections.details.sections.retryErrorMessage.errors.retryMessage.noRetryMessage}</span>
                            </ErrorAlert>
                        );
                        count++;
                    }
                }

            });
            if (axnuiContent.policyDecisionRetryMessage['default']?.retryMessage === '') {
                policyConfigDecisionsRetryErrors['default'] = (
                    <ErrorAlert key={'default'}>
                        <span>{resources.pages.verificationServiceDetails.tabs.policies.sections.details.sections.retryErrorMessage.errors.retryMessage.noRetryMessage}</span>
                    </ErrorAlert>
                );
                count++;
            }
        }
        const properties = policies[0].properties;

        if (policyType === PolicyTypes.TRUST_SCORE) {
            const stepUpEnabled = policies[0].stepUpEnabled;
            if (stepUpEnabled) {

                const hasStepUpApiKey = properties.find(property => property.name === "stepUp.apiKey" && property.value !== '');

                if (!hasStepUpApiKey) {
                    count++;
                    noStepUpApiKeyError = (
                        <ErrorAlert>
                            <span>{resources.pages.verificationServiceDetails.tabs.policies.sections.details.sections.trustScore.errors.stepUpApiKey.noStepUpKey}</span>
                        </ErrorAlert>
                    );
                }
            }
        } else if (policyType === PolicyTypes.ALWAYS_OBLIGATE) {
            const hasObligationApiKey = properties.find(property => (property.name || "").toLowerCase() === "obligation.apikey" && property.value !== '');

            if (!hasObligationApiKey) {
                count++;
                noStepUpApiKeyError = (
                    <ErrorAlert>
                        <span>{resources.pages.verificationServiceDetails.tabs.policies.sections.details.sections.trustScore.errors.stepUpApiKey.noStepUpKey}</span>
                    </ErrorAlert>
                );
            }
        }
    }

    return {
        policyConfigDecisionsRetryErrors,
        noStepUpApiKeyError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.policies.tabName} errorCount={count} />
    };
}
